import { findAllUsers, queryKeys } from "@dutyon/apis";
import { LoadingOverlay, TableContainer, Text, TitleContainer } from "@dutyon/ui-kit";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { parseAsInteger, parseAsString, useQueryState } from "nuqs";
import { useNavigate } from "react-router-dom";
import { UserSearchBox } from "../../components/UserSearchBox";
import { UserTable } from "../../components/UserTable";

export function UserListPage() {
  const navigate = useNavigate();

  const [page, setPage] = useQueryState("page", parseAsInteger.withDefault(1));
  const [limit, setLimit] = useQueryState("limit", parseAsInteger.withDefault(10));

  const [name, setName] = useQueryState("name", parseAsString.withDefault(""));
  const [email, setEmail] = useQueryState("email", parseAsString.withDefault(""));
  const [phone, setPhone] = useQueryState("phone", parseAsString.withDefault(""));

  const filter = { name, email, phone };

  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: queryKeys.users.list({ page, limit, filter }),
    queryFn: () =>
      findAllUsers({
        page,
        limit,
        filter: {
          name: name || undefined,
          email: email || undefined,
          phone: phone || undefined,
        },
      }),
    placeholderData: keepPreviousData,
  });

  const users = data?.list || [];
  const total = data?.total || 0;

  const handleFilterChange = (newFilter: { name?: string; email?: string; phone?: string }) => {
    setName(newFilter.name || null);
    setEmail(newFilter.email || null);
    setPhone(newFilter.phone || null);
    setPage(1);
  };

  return (
    <TitleContainer
      title="유저 리스트"
      rightSection={
        <UserSearchBox value={filter} onChange={handleFilterChange} loading={isFetching} />
      }
    >
      <div style={{ position: "relative" }}>
        <LoadingOverlay visible={isLoading || isFetching} overlayProps={{ blur: 1 }} />

        {isError ? (
          <Text c="red" ta="center" py="xl">
            데이터를 불러오는 중 오류가 발생했습니다.
          </Text>
        ) : (
          <TableContainer
            page={page}
            onPageChange={setPage}
            limit={limit}
            onLimitChange={setLimit}
            total={total}
            limitOptions={[
              { label: "10개씩", value: "10" },
              { label: "20개씩", value: "20" },
              { label: "50개씩", value: "50" },
              { label: "100개씩", value: "100" },
            ]}
            minWidth={800}
          >
            <UserTable
              users={users}
              isLoading={isLoading}
              onDetailClick={(id: string) => navigate(`/users/${id}`)}
            />
          </TableContainer>
        )}
      </div>
    </TitleContainer>
  );
}
